var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useMemo } from 'react';
import styled from '@mui/material/styles/styled';
import Box from '../Box';
import Actions from '../Actions';
import Typography from '../Typography';
import { isFunction } from '../../utils';
var InfoItemRoot = styled(Box)(function (_a) {
    var theme = _a.theme;
    return ({
        minHeight: '60px',
        width: '100%',
        display: 'flex',
        position: 'relative',
        alignItems: 'center',
        justifyContent: 'flex-start',
        paddingLeft: theme.spacing(4.5),
        paddingRight: theme.spacing(2),
        borderTop: '1px solid #f4f4f0',
        '& .actions-container': {
            position: 'absolute',
            top: '50%',
            right: 0,
            transform: 'translateY(-50%)',
        },
        '& .action-hover': {
            visibility: 'hidden',
        },
        '&:hover .action-hover': {
            visibility: 'visible',
        }
    });
});
var RightContentContainer = styled(Box)({
    flexGrow: 1,
    position: 'relative',
    width: '100%',
    overflow: 'hidden'
});
/**
 * @description: 右侧内容渲染函数  主要区分点：渲染的颜色不同
 * @param {*} a 正常文字
 * @param {*} b disabledEdit 禁止点击
 * @param {*} c auxiliaryText 辅助文字
 */
var renderRigthContent = function (a, b, c) {
    var colorConfig = {};
    if (b) {
        colorConfig.color = 'disabled';
    }
    else if (!a && c) {
        colorConfig.color = 'secondary';
    }
    return React.createElement(Typography, __assign({ variant: "body2", sx: { minHeight: 32 } }, colorConfig), a || c);
};
/**
 * @description: 自定义---渲染action
 * @param a renderAction | render
 */
var renderElement = function (a) {
    var rest = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        rest[_i - 1] = arguments[_i];
    }
    if (isFunction(a)) {
        return a.apply(void 0, rest);
    }
    else {
        return a;
    }
};
var RightContent = function (props) {
    var renderProps = props.renderProps, data = props.data, disabledEdit = props.disabledEdit, auxiliaryText = props.auxiliaryText;
    if (renderProps) {
        return renderElement(renderProps, data);
    }
    else {
        return renderRigthContent(data, disabledEdit, auxiliaryText);
    }
};
var HoverActions = function (props) {
    var renderActionsProps = props.renderActionsProps, actions = props.actions, useHover = props.useHover;
    var action = !!renderActionsProps ? renderElement(renderActionsProps) : (React.createElement(Actions, { actions: actions }));
    if (!useHover) {
        return action;
    }
    return (React.createElement(Box, { className: "action-hover actions-container" }, action));
};
var InfoItem = function (props) {
    var row = props.row, data = props.data;
    var _a = row || {}, label = _a.label, actions = _a.actions, renderActionsProp = _a.renderActions, renderProp = _a.render, auxiliaryText = _a.auxiliaryText, _b = _a.useHover, useHover = _b === void 0 ? true : _b;
    var disabledEdit = useMemo(function () { return (actions === null || actions === void 0 ? void 0 : actions.length) < 1 && !renderActionsProp; }, [actions, renderActionsProp]);
    return (React.createElement(InfoItemRoot, null,
        React.createElement(Box, { sx: { alignSelf: 'flex-start', mt: '18px' } },
            React.createElement(Typography, { variant: "body2", color: "secondary", weight: "medium", sx: { flexShrink: 0, width: 165 } }, label)),
        React.createElement(RightContentContainer, null,
            React.createElement(RightContent, { renderProps: renderProp, data: data, auxiliaryText: auxiliaryText, disabledEdit: disabledEdit }),
            !disabledEdit && React.createElement(HoverActions, { useHover: useHover, renderActionsProps: renderActionsProp, actions: actions }))));
};
export default InfoItem;
